module.exports = __webpack_public_path__ + "static/media/SaaSProductLandingPage.bea0b53c.jpeg";